import {
  addDoc,
  collection,
  doc,
  getDocs,
  serverTimestamp,
} from "firebase/firestore";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { auth, firestoredDB, saveImageToStorage } from "../config/firebase";
import GenerateImageRecipe from "./open-ai/GenerateImageRecipe";
import GenerateInstructions from "./open-ai/GenerateInstructions";
import { clearInstructions } from "../redux/instructions";
import {
  clearTitle,
  emptyRecipeAllImageByDishNumber,
  resetImageGenerationCount,
  setDishImage,
} from "../redux/title";
import { decreamentRecipeTokens } from "../redux/tokens";
import { updateUserTokensV2 } from "../utils/apiServices/usersService";

// import firebase from 'firebase/app';
import "firebase/storage";
import { setImage } from "../redux/image";
import AddToCookbookModal from "./alerts/AddToCookbookModal";
import { playAudio } from "../utils/btnAudio";
import { IoArrowBackCircleSharp, IoSearchSharp } from "react-icons/io5";
import { extractDishTitle, removeFirstTitleLine } from "../utils/extractTitle";
import { CButton } from "./CommonComponents";
import axios from "axios";
import { saveImageToStorageFunctionService } from "../utils/apiServices/firebaseImageStorageService";
import { setShowNavigationWarning } from "../redux/ui-slice";

function DisheSingle() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const moviesCollectionRef = collection(firestoredDB, "CookBook");

  const {
    user: { uid },
  } = useSelector((state) => state.auth.user);
  const { dishTokens, recipeTokens } = useSelector((state) => state.tokens);

  const { prompt: recipePrompt } = useSelector((state) => state.recipe);
  const { title } = useSelector((state) => state.title);
  const { dishNumber } = useSelector((state) => state.title);
  const abc = useSelector((state) => state);
  console.log(abc, "Abccc");
  const { image } = useSelector((state) => state.image);
  const { dish1 } = useSelector((state) => state.dish);
  const { prompt } = useSelector((state) => state.prompt);
  const { ingredients } = useSelector((state) => state.ingredients);
  const { instructions } = useSelector((state) => state.instructions);
  const [add, setAdd] = useState("Add To Cookbook");
  const [openAddToCookbookModal, setOpenAddToCookbookModal] = useState(false);
  // history state
  const [history, setHistory] = useState([]);
  // const [title, setTitle] = useState("");
  const [alreadySaved, setAlreadySaved] = useState(false);
  const contentRef = useRef(null);
  const [displayedText, setDisplayedText] = useState("");
  const [oldInstructions, setOldInstructions] = useState("");
  const [loading, setLoading] = useState(false);
  const [listsData, setListsData] = useState([]);
  const [listDropDownOptions, setListDropDownOptions] = useState([]);
  const [selectedCookbookList, setSelectedCookbookList] = useState({ id: 1 });
  const [isFirstVariant, setIsFirstVariant] = useState(false);

  const onSubmitRecipe = async () => {
    setOpenAddToCookbookModal(false);

    if (recipeTokens <= 0) {
      Swal.fire({
        icon: "info",
        title: "You are out of Recipe Tokens",
        showConfirmButton: true,
        timer: 2000,
      });
      return;
    }

    if (alreadySaved) {
      Swal.fire({
        icon: "info",
        title: "Dish is Already Saved in the cookbook",
        showConfirmButton: false,
        timer: 2000,
      });
      return;
    }
    setLoading(true);
    setAdd("Adding...");
    dispatch(setShowNavigationWarning(false));
    // Call the function with your data
    // const { data } = await saveImageToStorage({ imageUrl: image });
    const data = await saveImageToStorageFunctionService(image);

    try {
      const res = await addDoc(moviesCollectionRef, {
        userId: auth?.currentUser?.uid,
        description: instructions || null,
        ingredients: instructions || null,
        imageUrl: data || null,
        title: title ? title : dish1,
        listId: selectedCookbookList?.id == 1 ? null : selectedCookbookList?.id,
        createdAt: serverTimestamp(),
      });

      setAlreadySaved(true);

      Swal.fire({
        icon: "success",
        title: "Recipe added successfully",
        showConfirmButton: false,
        timer: 3000,
        confirmButtonColor: "#f0481a",
      });
      setAdd("Add To Cookbook");
      setLoading(false);

      //  const dbRes = await updateUserTokensV2(uid, "recipe");
      //  console.log(dbRes, "dbRes");
      //  if (dbRes) {
      //    dispatch(decreamentRecipeTokens());
      //  }

      //   // if (
      //   //   updateUserTokens(
      //   //     firestoredDB,
      //   //     collection,
      //   //     query,
      //   //     where,
      //   //     getDocs,
      //   //     updateDoc,
      //   //     doc,
      //   //     uid,
      //   //     "download"
      //   //   )
      //   // ) {
      //   //   dispatch(incrementDownloadTokens());
      //   // }
    } catch (err) {
      setLoading(false);
      Swal.fire({
        icon: "info",
        title: err.message,
        showConfirmButton: false,
        timer: 2000,
      });
    }
  };

  const findVariant = () => {
    if (recipeTokens <= 0) {
      Swal.fire({
        icon: "info",
        title: "You are out of Recipe Tokens",
        showConfirmButton: true,
        timer: 2000,
      });

      return;
    }

    if (alreadySaved) {
      setAlreadySaved(false);
      dispatch(setImage(""));
      dispatch(setShowNavigationWarning(false));
      dispatch(emptyRecipeAllImageByDishNumber(dishNumber));
      dispatch(resetImageGenerationCount());
      dispatch(
        setDishImage({
          dishNumber,
          url: "",
        })
      );
      dispatch(clearTitle());
      setHistory([
        ...history,
        {
          role: "user",
          content: recipePrompt,
        },
        {
          role: "system",
          content: instructions,
        },
        {
          role: "user",
          content:
            "Find a Variant. The response should be in detail as told. with a very short intro of dish.",
        },
      ]);
      return;
    }

    // if (!isFirstVariant) {
    console.log("hereee", dishNumber);
    dispatch(emptyRecipeAllImageByDishNumber(dishNumber));
    // setIsFirstVariant(true);
    // }
    Swal.fire({
      title: "Leave Recipe?",
      text: "This Will Conclude Your Token",
      icon: "warning",
      showDenyButton: true,
      confirmButtonText: "Leave - Do Not Save",
      denyButtonText: `Leave - But Save Recipe`,
      showCloseButton: true,
      dangerMode: true,
    }).then(async (result) => {
      if (result.isDenied) {
        await onSubmitRecipe();
        setAlreadySaved(false);
        dispatch(setImage(""));
        dispatch(setShowNavigationWarning(false));
        dispatch(emptyRecipeAllImageByDishNumber(dishNumber));
        dispatch(resetImageGenerationCount());
        dispatch(
          setDishImage({
            dishNumber,
            url: "",
          })
        );
        dispatch(clearTitle());

        setHistory([
          ...history,
          {
            role: "user",
            content: recipePrompt,
          },
          {
            role: "system",
            content: instructions,
          },
          {
            role: "user",
            content:
              "Find a Variant. The response should be in detail as told. with a very short intro of dish.",
          },
        ]);

        dispatch(clearInstructions());
        return;
      } else if (result.isConfirmed) {
        setAlreadySaved(false);
        dispatch(setImage(""));
        dispatch(setShowNavigationWarning(false));
        dispatch(emptyRecipeAllImageByDishNumber(dishNumber));
        dispatch(resetImageGenerationCount());
        dispatch(
          setDishImage({
            dishNumber,
            url: "",
          })
        );
        dispatch(clearTitle());
        setHistory([
          ...history,
          {
            role: "user",
            content: recipePrompt,
          },
          {
            role: "system",
            content: instructions,
          },
          {
            role: "user",
            content:
              "Find a Variant. The response should be in detail as told. with a very short intro of dish.",
          },
        ]);

        dispatch(clearInstructions());
        return;
      } else {
        return;
      }
    });
  };

  useEffect(() => {
    if (contentRef.current) {
      contentRef.current.scrollTop = contentRef.current.scrollHeight;
    }
  }, [displayedText]);

  const makeDropDownOptionsForListPopup = (lists) => {
    const options = [{ id: 1, name: "General" }];
    lists?.map((item, index) => {
      options?.push({
        id: item?.id,
        name: item?.name,
      });
    });
    setSelectedCookbookList(options[0]);
    setListDropDownOptions(options);
  };
  //Get Lists data
  const listCollectionRef = collection(firestoredDB, "Lists");

  const getLists = async () => {
    try {
      // const data = await getDocs(listCollectionRef);
      const data = await getDocs(listCollectionRef);
      const filteredData = data.docs
        .map((doc) => ({
          ...doc.data(),
          id: doc.id,
          createdAt: doc._document.createTime.timestamp.seconds,
        }))
        .sort((a, b) => a.createdAt - b.createdAt);

      const userData = filteredData.filter((item) => {
        return item.userId === auth?.currentUser?.uid;
      });
      makeDropDownOptionsForListPopup(userData);
      setListsData(userData);
    } catch (err) {
      console.error(err);
    }
  };

  const onAddToCookBookModalClick = async () => {
    if (alreadySaved) {
      Swal.fire({
        icon: "info",
        title: "Dish is Already Saved in the cookbook",
        showConfirmButton: false,
        timer: 2000,
      });
    } else {
      setOpenAddToCookbookModal(true);
      // setLoading(true);
      if (listDropDownOptions?.length == 0) {
        await getLists();
      }
    }
  };

  return (
    <section className="relative ">
      <div ref={contentRef}>
        {displayedText ? (
          <div className="flex justify-between flex-col lg:flex-row gap-4 mb-4">
            <div className="flex  items-center gap-4 lg:w-[60%] w-full">
              <button
                onClick={() => {
                  Swal.fire({
                    title: "Leave Recipe?",
                    text: "This Will Conclude Your Token",
                    icon: "warning",
                    showDenyButton: true,
                    confirmButtonText: "Leave - Do Not Save",
                    denyButtonText: `Leave - But Save Recipe`,
                    showCloseButton: false,
                    dangerMode: true,
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                  }).then(async (result) => {
                    if (result.isDenied) {
                      return;
                    } else {
                      navigate("/get-dishes");
                    }
                  });
                }}
                className="cursor-pointer text-3xl text-white "
              >
                <IoArrowBackCircleSharp size={50} />
              </button>
              <span className="text-2xl font-bold dark:text-white text-black">
                {extractDishTitle(title, 2)?.replaceAll("*", "")}
              </span>
            </div>

            <div>
              <CButton
                variant="red"
                type="button"
                // onClick={openModal}
                onClick={onAddToCookBookModalClick}
                disabled={loading}
                className="
            "
              >
                {add}
              </CButton>
            </div>
          </div>
        ) : (
          <div></div>
        )}
        <article className="">
          <figure className=" flex justify-center">
            <GenerateImageRecipe prompt={title} disheSinglePage />
          </figure>

          <GenerateInstructions
            prompt={recipePrompt}
            history={history ? history : null}
            title={title}
            displayedText={removeFirstTitleLine(displayedText)}
            setDisplayedText={setDisplayedText}
            oldInstructions={oldInstructions}
            setOldInstructions={setOldInstructions}
          />
        </article>
        {displayedText ? (
          <div className="mt-4 flex w-full gap-4 flex-col md:flex-row ">
            <CButton
              variant="red"
              type="button"
              onClick={async () => {
                playAudio();
                if (!alreadySaved) {
                  Swal.fire({
                    title: "Leave Recipe?",
                    text: "This Will Conclude Your Token",
                    icon: "warning",
                    showDenyButton: true,
                    confirmButtonText: "Leave - Do Not Save",
                    denyButtonText: `Leave - But Save Recipe`,
                    showCloseButton: false,
                    dangerMode: true,
                    allowEscapeKey: false,
                  }).then(async (result) => {
                    dispatch(setShowNavigationWarning(false));
                    if (result.isDenied) {
                      await onSubmitRecipe();
                      navigate("/discover-dishes");
                    } else if (result.isConfirmed) {
                      navigate("/discover-dishes");
                    } else {
                      return;
                    }
                  });
                } else {
                  navigate("/discover-dishes");
                }
              }}
              className="
            w-full"
              disabled={loading}
            >
              <IoSearchSharp className="text-xl mr-2 font-bold" />
              Start Fresh
            </CButton>
            <CButton
              variant="red"
              type="button"
              // onClick={openModal}
              onClick={onAddToCookBookModalClick}
              disabled={loading}
              className="w-full
            "
            >
              {add}
            </CButton>
            <CButton
              variant="orange"
              type="button"
              onClick={() => {
                findVariant();
              }}
              className="
            w-full"
              disabled={loading}
            >
              Find Variant
            </CButton>
          </div>
        ) : (
          <div></div>
        )}
      </div>

      <div className="fixed flex md:space-x-3 md:flex-row flex-col w-fit left-0 right-0 z-90 bottom-4 m-auto">
        <div className="flex space-x-2 justify-center items-center "></div>
        <div className="flex space-x-2 justify-center items-center"></div>
      </div>

      <AddToCookbookModal
        isOpen={openAddToCookbookModal}
        onDoneClick={() => onSubmitRecipe()}
        onCloseClick={() => {
          setOpenAddToCookbookModal(false);
          setLoading(false);
        }}
        listDropDownOptions={listDropDownOptions}
        selectedOption={selectedCookbookList}
        setSelectedOption={setSelectedCookbookList}
      />
    </section>
  );
}

export default DisheSingle;
